import React from "react";
import { useAuth } from "../contextos/AuthProvider";
import Swal from 'sweetalert2'
function ResetPassword() {

    const { pideReseteo } = useAuth();

    const triggerResetEmail = async () => {
       
        Swal.fire({
            title: 'Ingrese su correo SmartFeCr',
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            showLoaderOnConfirm: true,
            preConfirm: async (login) => {
                
                return await pideReseteo(login);
               
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
           //console.log(result)
            if (result.isConfirmed) {
               // console.log(result.value);
                if (result.value === 'Correo de restablecimiento enviado correctamente.') {
                    Swal.fire('se ha enviado un correo para el cambio de contraseña. Valore que el correo pudo haber llegado a spam (no deseados)')
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Alerta...',
                        text: result.value

                    })
                }
            }

        })

    }

    return (
        <div className="resetPassword-main">

            <button style={{ width: '100%' }} type="button" onClick={() => (triggerResetEmail())}>Recordar clave</button>

        </div>
    )
}

export default ResetPassword;
